import type { PContainer, PLayer } from '../../engine/aliases'
import { assert } from '../../lib/assert-sidecar'
import { common } from '../../main/common-sidecar'

export function getMasterLayers() {
  assert.notNil(_masterLayers)
  return _masterLayers
}
export function getLayers() {
  assert.notNil(_layers)
  return _layers
}

export interface IGolfMasterLayers {
  main: PLayer
  ui: PLayer
  debug: PLayer
}

export interface IGoatLayers {
  background: PContainer
  pieces: PContainer
  particles: PContainer

  uiOnCam: PContainer
  uiGame: PContainer
  uiMenu: PContainer
  uiMenuMain: PContainer
  uiDialog: PContainer
  uiMessage: PContainer

  debug: PContainer
  debugPhysics: PContainer
}

let _masterLayers: IGolfMasterLayers | null = null
let _layers: IGoatLayers | null = null

let _layersOnMainCamera: PContainer[] = []
let _layersUi: PContainer[] = []
export function getLayersOnMainCamera() {
  return _layersOnMainCamera
}
export function getLayersUi() {
  return _layersUi
}

let depth = 100

export function create() {
  let scene = common.getPhaserScene()

  _masterLayers = {
    main: scene.add.layer(),
    ui: scene.add.layer(),
    debug: scene.add.layer(),
  }

  _layers = {
    background: createLayer(_masterLayers.main, true),

    pieces: createLayer(_masterLayers.main),

    particles: createLayer(_masterLayers.main),

    uiOnCam: createLayer(_masterLayers.main),
    uiGame: createLayer(_masterLayers.ui, true),
    uiMenu: createLayer(_masterLayers.ui, true),
    uiMenuMain: createLayer(_masterLayers.ui, true),
    uiDialog: createLayer(_masterLayers.ui, true),
    uiMessage: createLayer(_masterLayers.ui, true),

    debug: createLayer(_masterLayers.debug),
    debugPhysics: createLayer(_masterLayers.main),
  }
}
export function updateAll() {}

export function createExternal(baseLayer: PContainer) {
  let scene = common.getPhaserScene()
  let c = scene.add.container(0, 0)
  baseLayer.add(c)
  return c
}

function createLayer(masterLayer: PLayer, isUi: boolean = false) {
  let scene = common.getPhaserScene()

  assert.notNil(masterLayer)
  assert.notNil(_masterLayers)

  let c = scene.add.container(0, 0)
  masterLayer.add(c)

  // masterLayer.add(c)
  c.depth = depth
  depth += 100

  if (masterLayer === _masterLayers.main) {
    if (!isUi) {
      _layersOnMainCamera.push(c)
    }
  }
  if (isUi) {
    _layersUi.push(c)
  }

  if (isUi) {
    c.scrollFactorX = 0
    c.scrollFactorY = 0
  }

  return c
}
